<template>
  <div class="finance">
    <b-media class="text-center parcourpatient shadow p-3 mb-3 bg-white rounded" v-if="!mobileView">
      <div class="container">
        <div class="row d-flex justify-content-md-around finance__content">
          <div class="">
          <div class="finance__content--box col" :class="{ 'text-primary' : !isHiddenSouscription }">
            <div class="finance__content--box-icon">
              <a v-on:click="isHiddenAdministratif = true, isHiddenSouscription = false, Parcours_activites_controle = true, Parcours_medicaux_financiers = true, Bilan = true, arrow1 = false, arrow2=false, arrow3 = false, arrow4 = false"
                href="#souscription">
                <img src="/img/icons/parcours_soins/Group60.png" alt="" class="finance--icone"
                :class="{ 'icon1' : !isHiddenSouscription }">
              </a>
            </div>
            <span class="mt-4">Souscription</span>
           
            </div>
          </div>

            <div class="row">
               <div :class="[!arrow1 ? 'colour-arrow-dark' : 'colour-arrow-success']"></div>
                <div :class="[!arrow1 ? 'arrow-circle-dark' : 'arrow-circle-success']"></div>
              </div>

          <div class="col-6 col-md-4 col-lg" :class="{ 'text-primary' : !isHiddenAdministratif }">
            <div>
              <a v-on:click="isHiddenAdministratif = false, isHiddenSouscription = true, Parcours_activites_controle = true, Parcours_medicaux_financiers = true, Bilan = true, arrow1 = true, arrow2=false, arrow3 = false, arrow4 = false "
                href="#activite_medico_administratif">
                <img src="/img/icons/parcours_soins/Group57.png" alt="" class="finance--icone"
                :class="{ 'icon1' : !isHiddenAdministratif }">
              </a>
            </div>
            <span class="mt-4">Parcours Médico-Administratifs</span>
          </div>

 
            <div class="row">
                <div :class="[!arrow2 ? 'colour-arrow-dark' : 'colour-arrow-success']"></div>
               <div :class="[!arrow2 ? 'arrow-circle-dark' : 'arrow-circle-success']"></div>
              </div>

          <div class="col-6 col-md-4 col-lg" :class="{ 'text-primary' : !Parcours_activites_controle }">
            <div>
              <a href="#activite_medecin_controle"
                v-on:click="isHiddenAdministratif = true, isHiddenSouscription = true, Parcours_activites_controle = false, Parcours_medicaux_financiers = true, Bilan = true, arrow1 = true, arrow2=true, arrow3 = false, arrow4 = false">
                <img src="/img/icons/parcours_soins/Group59.png" alt="" class="finance--icone"
                :class="{ 'icon1' : !Parcours_activites_controle }">
              </a>
            </div>
            <span class="mt-4">Parcours activités Medecin Contrôle</span>
          </div>

            <div class="row">
                 <div :class="[!arrow3 ? 'colour-arrow-dark' : 'colour-arrow-success']"></div>
                <div :class="[!arrow3 ? 'arrow-circle-dark' : 'arrow-circle-success']"></div>
              </div>

          <div class="col-6 col-md-4 col-lg" :class="{ 'text-primary' : !Parcours_medicaux_financiers }">
            <div>
              <a href="#Parcours_medicaux_financiers"
                v-on:click="isHiddenAdministratif = true, isHiddenSouscription = true, Parcours_activites_controle = true, Bilan = true, Parcours_medicaux_financiers = false, arrow1 = true, arrow2=true, arrow3 = true, arrow4 = false">
                <img src="/img/icons/parcours_soins/activitésmédecin.png" alt="" 
                class="finance--icone"
                :class="{ 'icon1' : !Parcours_medicaux_financiers }">
              </a>
            </div>
            <span class="mt-4">Parcours médicaux et financiers</span>
           
          </div>

           <div class="row">
          
                <div :class="[!arrow4 ? 'colour-arrow-dark' : 'colour-arrow-success']"></div>
                <div :class="[!arrow4 ? 'arrow-circle-dark' : 'arrow-circle-success']"></div>
              </div>
              
          <div class="col-6 col-md-4 col-lg" :class="{ 'text-primary' : !Bilan }">
            <div>
              <a href="#Parcours_medicaux_financiers"
                v-on:click="isHiddenAdministratif = true, isHiddenSouscription = true, Parcours_activites_controle = true, Parcours_medicaux_financiers = true, Bilan = false, arrow1 = true, arrow2 = true, arrow3 = true, arrow4 = true">
                <img src="/img/icons/parcours_soins/Group58.png" alt="" 
                class="finance--icone"
                :class="{ 'icon1' : !Bilan }">
              </a>
            </div>
            <span>Bilans</span>
          </div>
        </div>
      </div>
    </b-media>
    <b-media id="myDIV" class="text-center mobileUl shadow mb-10 container d-flex" v-else>
      <div class="row" v-on:click="dropDown, dropHidden=true">
      <div class="col-10 elementdiv" @click="isdropHidden = !isdropHidden">
          <div class="mobileLi" v-if="!isHidden">
            <a v-on:click="isHiddenAdministratif = false, isHiddenSouscription = true, Parcours_activites_controle = true, Parcours_medicaux_financiers = true, Bilan = true, dropHidden=true" href="javascript:void(0)">
                <img src="/img/icons/parcours_soins/Parcours_medico_administratifs.png" alt="" class="icon2">
              </a>
              
            <a href="javascript:void(0)" class="text-white mt--4 ml-4" v-on:click="dropDown, dropHidden=true">Souscription</a>
          </div>
            

            <div class="row mobileLi" v-if="isGreen">
            <div class="col-3 ml--4">
              <a v-on:click="isHiddenAdministratif = false, isHiddenSouscription = true, Parcours_activites_controle = true, Parcours_medicaux_financiers = true, Bilan = true, dropHidden=true" href="javascript:void(0)">
                <img src="/img/icons/parcours_soins/Parcours_medico_administratifs.png" alt="" class="icon2">
                </a></div>
                <div class="col-9 mobileElement">
            <a href="javascript:void(0)" class="text-white" v-on:click="dropDown, dropHidden=true">Parcours medico administratifs</a></div>
          <!--   <i class="fa fa-check-circle text-success"></i> -->
           </div>


            <div class="row mobileLi" v-if="isYellow">
            <div class="col-3 ml--4">
            <a href="javascript:void(0)"
               v-on:click="isHiddenAdministratif = true, isHiddenSouscription = true, Parcours_activites_controle = false, Parcours_medicaux_financiers = true, Bilan = true, dropHidden=true">
                <img src="/img/icons/parcours_soins/Group59.png" alt="" class="icon2">
              </a> </div>
              <div class="col-9 mobileElement">
            <a href="javascript:void(0)" class="text-white" v-on:click="dropDown, dropHidden=true">Parcours activites medecin controle</a></div>
           <!-- <i class="fa fa-check-circle  text-success"></i> -->
           </div>


            <div class="row mobileLi" v-if="isRed">
              <div class="col-2 ml--4">
              <a href="#Parcours_medicaux_financiers"
               v-on:click="isHiddenAdministratif = true, isHiddenSouscription = true, Parcours_activites_controle = true, Bilan = true, Parcours_medicaux_financiers = false, dropHidden=true">
                <img src="/img/icons/parcours_soins/activitésmédecin.png" alt="" class="icon2">
              </a></div>
              <div class="col-10 mobileElement">
              <a href="javascript:void(0)" class="text-white" v-on:click="dropHidden=true">Parcours medicaux financiers</a></div>
           <!-- <i class="fa fa-check-circle text-success"></i> -->
             </div>


            <div class="row mobileLi" v-if="bilanHide">
            <div class="col-3 ml--4">
              <a href="#Parcours_medicaux_financiers"
                v-on:click="isHiddenAdministratif = true, isHiddenSouscription = true, Parcours_activites_controle = true, Parcours_medicaux_financiers = true, Bilan = false, dropHidden=true">
                <img src="/img/icons/parcours_soins/Group58.png" alt="" class="icon2">
              </a></div>
              <div class="col-6 mobileElement">
              <a href="javascript:void(0)" class="text-white mt-2 ml-5" v-on:click="dropHidden=true">Bilan</a></div>
           <!-- <i class="fa fa-exclamation-circle text-danger"></i> -->
            </div>
          </div> 
          <div class="col-2 float-right">
              <a href="javascript:void(0)" class="mobileDropbtn fas text-white" v-on:click="dropDown, dropHidden=true">&#xf106;</a>
            </div>
          </div>

             
              <div class="mobileDropdown-content" id="myDropdown"  v-if="dropHidden">

                <div class="row components" :class="{ 'comphover' : !isHidden}">
                 <a href="#activite_amas">
                    <img src="/img/icons/parcours_soins/Parcours_medico_administratifs.png" alt="" class="icondrop">
                  </a>
                <a href="#souscription" class="componentA text-dark" @click="isRed = false, isGreen=false, isYellow=false, isHidden=false, bilanHide=false, dropHidden=false, isHiddenAdministratif = true, isHiddenSouscription = false, Parcours_activites_controle = true, Parcours_medicaux_financiers = true, Bilan = true">Souscription</a>
                </div>

                <div class="row components" :class="{ 'comphover' : isGreen}">
                  <a class="col-3" href="#activite_amas">
                  <img src="/img/icons/parcours_soins/Parcours_medico_administratifs.png" alt="" class="icondrop">
                  </a>
                <a class="col-9 componentA text-dark" href="#activite_amas" @click="isRed = false, isGreen=true, isYellow=false, isHidden=true, bilanHide=false, dropHidden=false, isHiddenAdministratif = false, isHiddenSouscription = true, Parcours_activites_controle = true, Parcours_medicaux_financiers = true, Bilan = true">Parcours medico administratifs</a>
               </div>

               <div class="row components" :class="{ 'comphover' : isYellow}">
                <a class="col-3" href="#activite_medecin_controle">
                <img src="/img/icons/parcours_soins/Group59.png" alt="" class="icondrop">
              </a> 
               <a class="col-9 componentA text-dark" href="#activite_medecin_controle" @click="isRed = false, isGreen=false, isYellow=true, isHidden=true, bilanHide=false, dropHidden=false, isHiddenAdministratif = true, isHiddenSouscription = true, Parcours_activites_controle = false, Parcours_medicaux_financiers = true, Bilan = true">Parcours activites controle</a>
                </div>
                 <div class="row components" :class="{ 'comphover' : isRed}">
                  <a class="col-3" href="#Parcours_medicaux_financiers">
                    <img src="/img/icons/parcours_soins/activitésmédecin.png" alt=""     
                    class="icondrop">
                  </a>
                <a class="col-9 componentA text-dark" href="#Parcours_medicaux_financiers" @click="isRed = true, isGreen=false, isYellow=false, isHidden=true, bilanHide=false, dropHidden=false, isHiddenAdministratif = true, isHiddenSouscription = true, Parcours_activites_controle = true, Bilan = true, Parcours_medicaux_financiers = false">Parcours medicaux financiers</a>
                </div>
                 <div class="row components" :class="{ 'comphover' : bilanHide}">
                  <a class="col-3" href="#Parcours_medicaux_financiers">
                <img src="/img/icons/parcours_soins/Group58.png" alt=""
                class="icondrop">
              </a>
                <a class="col-9 componentA text-dark" href="#Bilan" @click="isRed = false, isGreen=false, isYellow=false, isHidden=true, bilanHide=true, dropHidden=false, isHiddenAdministratif = true, isHiddenSouscription = true, Parcours_activites_controle = true, Parcours_medicaux_financiers = true, Bilan = false">Bilan</a>
              </div>
              </div>
     
          
    </b-media> 


    <b-container fluid>
      <b-row>
        <b-col md="12">
          <Souscription :dossier_medical_slug="file_id" v-if="!isHiddenSouscription" />
          <!--Design de la ligne de temps des activités médicaux-administrative (AMA) -->
          <div no-body v-if="!isHiddenAdministratif" :title="$tc('message.LigneTempsActivitéAMA', 1)">
              <TrajetMedicoAdministratif :dossier_medical_slug="file_id" />
          </div>

          <div  v-if="!Parcours_activites_controle" no-body :title="$tc('message.LigneTempsActiviteMedecinReferent', 1)">
            <TrajetMedecinControle :dossier_medical_slug="file_id" />
          </div>

          <div no-body  v-if="!Parcours_medicaux_financiers" :title="$tc('message.LigneTempsMedicofinanciere', 2)">
              <TrajetFinancier :dossier_medical_slug="file_id"/>
          </div>

          <div no-body v-if="!Bilan" :title="$tc('message.EtatfinContrat', 2)">
            <BilanLigneTemp :dossier_medical_slug="file_id"/>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
//import component
import TrajetMedicoAdministratif from './TrajetMedicoAdministratif'
import TrajetMedecinControle from './TrajetMedecinControle'

import TrajetFinancier from './TrajetFinancier'
import BilanLigneTemp from './BilanLigneTemp.vue';

import Souscription from './Souscription.vue'

export default {
  name: "Timeline",
  components: {
    TrajetFinancier,
    TrajetMedicoAdministratif,
    TrajetMedecinControle,
    Souscription,
    BilanLigneTemp,
  },

  computed: {
  },

  data() {
    return {
      isHidden: false,
      halfHide: false,
      isRed: false,
      isGreen: false,
      isYellow: false,
      bilanHide: false,
      mobileView: true,
      halfred: false,
      dropHidden: false,
      arrow1:false,
      arrow2:false,
      arrow3:false,
      arrow4:false,
      isHiddenSouscription: false,
      isHiddenAdministratif: true,
      Bilan: true,
      Parcours_activites_controle: true,
      Parcours_medicaux_financiers: true,
      file_id: this.$route.params.file,
    };
  },

  watch: {

  },

  methods: {   
    handleView() {
      this.mobileView = window.innerWidth <= 990;
         }, 
    dropDown() {
          var y = document.getElementById("myDIV")
          var x = document.getElementById("myDropdown");
          $('.mobileUl').click(function(){
           $('.mobileDropbtn').toggleClass("rotate");
         });
              if (x.style.display === "none") {
                x.style.display = "block";
                y.style.backgroundColor = "white";
              } else {
                x.style.display = "none";
                y.style.backgroundColor = "#2dcecc";
        }
      },
    getMedicalFile() {
        let args = {
            file: this.file_id
        };

        this.$store.dispatch("getMedicalFile", {
            args
        });
    },
  },
    created() {
    this.handleView();
      window.addEventListener('resize', this.handleView);
    },
  mounted() {
    this.getMedicalFile();
  },
};
</script>
